/**
 * Formats a 0-1 mastery score as a whole percent.
 *
 * Truncates, so every surface shows the same number. The toFixed pass clears
 * binary float error first: 0.29 * 100 is 28.999999999999996.
 */
export const toScorePercent = (mastery) =>
  Math.trunc(Number(((mastery ?? 0) * 100).toFixed(4)));
